import * as yup from "yup";

export const resetpasswordSchema = yup.object({
  password: yup
    .string()
    .required(`Password is required`)
    .min(8, `Password should be at least 8 characters`),
  confirmPassword: yup
    .string()
    .required(`Please re enter password to confirm`)
    .min(8, `Password should be at least 8 characters`)
    .oneOf([yup.ref('password')], 'Passwords must match')
});
